import { useCartContext } from "context/UseCartContext";
import React, { memo } from "react";
import ReactDOM from "react-dom";
import Modal from "./Modal";

function OpenModal() {
  const { modal } = useCartContext();

  if (!modal) return null;

  // Render into document.body so no parent stacking context
  // (sticky nav, overflow:visible, etc.) can clip or obscure the modal.
  return ReactDOM.createPortal(
    <>
      {/* Backdrop — sits below the modal card */}
      <div
        style={{
          position: "fixed", inset: 0, zIndex: 99998,
          background: "rgba(0,0,0,0.5)",
        }}
      />
      {/* Modal content — LoginModal / RegisterModal already render at z-index:99999 */}
      <Modal register={modal} />
    </>,
    document.body
  );
}

export default memo(OpenModal);